import { AxiosError } from 'axios';

import { demoAxios } from '../../services/axios/demo';

import {
  DemoErrorCode,
  DemoResolveError,
  DemoSessionConfig,
  DemoSessionWireResponse,
} from './types';

const HTTP_STATUS_TO_CODE: Record<number, DemoErrorCode> = {
  404: 'LINK_NOT_FOUND',
  410: 'LINK_EXPIRED',
  423: 'LINK_REVOKED',
  429: 'LINK_CAP_REACHED',
};

const normalize = (raw: DemoSessionWireResponse): DemoSessionConfig => ({
  feature_key: Array.isArray(raw.feature_key) ? raw.feature_key[0] : raw.feature_key,
  feature_label: raw.feature_label,
  expires_at: raw.expires_at,
  max_access: raw.max_access,
  access_count: raw.access_count,
  email: raw.email,
});

const toDemoError = (err: unknown): DemoResolveError => {
  const axiosErr = err as AxiosError<{ code?: DemoErrorCode; message?: string }>;
  const status = axiosErr?.response?.status;
  const body = axiosErr?.response?.data;
  const code: DemoErrorCode =
    body?.code ?? (status ? HTTP_STATUS_TO_CODE[status] : undefined) ?? 'NETWORK_ERROR';
  return new DemoResolveError(
    code,
    body?.message ?? axiosErr?.message ?? 'Demo link error',
    status
  );
};

export const resolveDemoLink = async (
  token: string,
  signal?: AbortSignal
): Promise<DemoSessionConfig> => {
  try {
    const { data } = await demoAxios.post<DemoSessionWireResponse>(
      '/auth/demo',
      { t: token },
      { signal }
    );
    return normalize(data);
  } catch (err) {
    throw toDemoError(err);
  }
};

export const getDemoSession = async (signal?: AbortSignal): Promise<DemoSessionConfig | null> => {
  try {
    const { data } = await demoAxios.get<DemoSessionWireResponse>('/user/demo/me', {
      signal,
    });
    return normalize(data);
  } catch (err) {
    const status = (err as AxiosError)?.response?.status;
    if (status === 401) return null;
    throw toDemoError(err);
  }
};
